export interface IRouterClient {
  name: string;
  url: string;
  client_key: string;
  widget_key: string;
  chat_key: string;
  service_area: string[];
  services: string[];
}

// before adding the routerClient,
// please ensure that the definition exists at:
// https://router.scheduleengine.net/definitions/{{routerClient}}/se_inc_def.js
export const clientRouterClients = [
  'goettl',
  'sila',
  'hollands',
  'eco',
  'greendot',
  'dauenhauer',
  'airco',
  'qualitycool',
  'ease',
  'southernair',
  'servicetoday',
  'airtron',
  'swiftbrothers',
  'ambientedge',
  'hbhomeservice',
  'progressiveairsystems',
  'rooterranger',
  'hoffmannbros',
  'laplante',
  'blueoxst',
  'roofingpups',
  'blaze',
  'snyderac',
];
